// ** React Imports
import React from "react";

// ** Third Party Imports
import { FormattedMessage } from "react-intl";

import ModalHOC from "../../hoc/Modal/ModalHOC";

const ModalInfoDepartments = props => {
    return (
        <div id="modal" className="modal">
            <div className="modal-background" onClick={props.closeModal}></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">{props.title}</p>
                    <button className="delete" aria-label="close" onClick={props.closeModal}></button>
                </header>

                <section className="modal-card-body">
                    <div className="content">
                        <p>
                            <FormattedMessage id="general.info_departments_1"/>
                        </p>
                        <p>
                            <FormattedMessage id="general.info_departments_2"/>
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default ModalHOC(ModalInfoDepartments);
